module.exports = {
      id: "bg_logo_samson-usage",
      viewBox: "0 0 1517.857 250",
      url: "/typo3conf/ext/samson_druck_sitepackage/Resources/Public/Theme/img/" + "sprite.svg#bg_logo_samson",
      toString: function () {
        return this.url;
      }
    }